import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AuthService from "../../services/auth";
import UserService from "../../services/user-service";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import EUPopup from "../updateExpensePop";
import ERPopup from "../removeExpensePop";
import ECPopup from "../copyExpensePop";
import { useHistory } from "react-router-dom";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import { ReactComponent as EditPic } from "../../assets/editpencil.svg";
import { ReactComponent as RemovePic } from "../../assets/redfilltrash.svg";
import { ReactComponent as CopyPic } from "../../assets/duplicate2.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styling/table.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Col } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import "../../styling/table.css";

import * as Scroll from "react-scroll";
import { ReactComponent as ExportIcon } from "../../assets/exportIcon.svg";
import { ReactComponent as SearchIcon } from "../../assets/searchIcon.svg";
import { CloseIconWithTooltip } from "./tutorialLanding";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableHead: {
    fontWeight: 600,
  },
});

const nrows = [
  {
    incomeStream: 1,
    name: "Hand Plane",
    date: "Nov 29 2021",
    amount: 4,
    site: "Lowe's",
    category: "Woodshop tools",
    note: "Replacing broken one",
    realDate: "2021-11-29T11:06:34.417Z",
  },
  {
    incomeStream: 1,
    name: "Oak 4x4x4",
    date: "Nov 29 2021",
    amount: 23,
    site: "Lowe's",
    category: "Lumber",
    note: "",
    realDate: "2021-11-29T11:06:34.417Z",
  },
  {
    incomeStream: 1,
    name: "Dado blade",
    date: "Nov 29 2021",
    amount: 40,
    site: "Lowe's",
    category: "Woodshop tools",
    note: "For making drawer",
    realDate: "2021-11-29T11:06:34.417Z",
  },
  {
    incomeStream: 1,
    name: "Dark walnut stain",
    date: "Nov 29 2021",
    amount: 13,
    site: "Lowe's",
    category: "Supplies",
    note: "Quart",
    realDate: "2021-11-29T11:06:34.417Z",
  },
];

export default function TutorialExpenseTable(props) {
  const classes = useStyles();
  const history = useHistory();
  const [isReplay, setIsReplay] = useState(
    history.location.search.includes("replay=true") ||
      history.location.pathname.includes("replay=true")
  );
  var scroll = Scroll.animateScroll;

  const [show, setShow] = useState(false);
  const [tutorialSource, setTutorialSource] = useState([]);

  useEffect(() => {
    if (props.step) {
      setShow(true);
    }
  }, [props.step]);

  useEffect(() => {
    UserService.onBoardingAnswer().then((response) => {
      response.data.status.map((data) => {
        setTutorialSource(data.platforms);
      });
    });
  }, []);

  const [tutorialIndex, setTutorialIndex] = useState(8);
  const [step9, setStep9] = useState(false);

  const handleClose = () => setStep9(false);

  const showstep9 = () => {
    setShow(false);
    setTutorialIndex(9);
    props.setCompleteTutorial(true);
    scroll.scrollToTop();
  };

  const endTutorial = async (e) => {
    e.preventDefault();
    setStep9(false);
    try {
      UserService.tutorialDone(AuthService.getCurrentUser()).then(() => {
        history.push("/");
      });
    } catch (e: any) {
      alert(e.message);
    }
  };

  function createColorDictionary() {
    return {
      "Woodshop tools": "#21A179",
      Lumber: "#7964D9",
      Supplies: "#EB6F2D",
    };
  }

  const handleStep9 = () => {
    const data: any = tutorialSource[0];
    const allSources: any = data.split(",").map((value) => value.trim());
    if (
      allSources.includes("Etsy") === true ||
      allSources.includes("etsy") === true
    ) {
      props.setCheckEtsySource(true);
      setShow(false);
      scroll.scrollToTop();
    } else {
      showstep9();
    }
  };

  function getColor(cell) {
    const colorDict = createColorDictionary();
    return colorDict[cell];
  }

  const popoverS8 = (
    <Popover id="popover-basic7" className="all-popover">
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Analytics</span>
        {isReplay && <CloseIconWithTooltip onClick={() => history.push("/")} />}
      </Popover.Title>
      <Popover.Content className="popover-content">
        You can filter, sort, edit, copy and remove expenses.
      </Popover.Content>
      <Button onClick={handleStep9} className="popover-button">
        Next
      </Button>
    </Popover>
  );

  function actionformat(cell, row) {
    return (
      <div>
        <Popup
          trigger={
            <button className="actionbuttonE" disabled>
              <EditPic stroke="grey" />
            </button>
          }
          modal
          nested
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Update Expense </div>
              <div className="content">
                <EUPopup keydata={row} categories={props.categories} />
                <br />
              </div>
            </div>
          )}
        </Popup>
        <Popup
          trigger={
            <button className="actionbuttonE" disabled>
              <CopyPic stroke="grey" />
            </button>
          }
          modal
          nested
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Duplicate Expense </div>
              <div className="content">
                <ECPopup keydata={row} categories={props.categories} />
                <br />
              </div>
            </div>
          )}
        </Popup>
        <Popup
          trigger={
            <button className="actionbutton removebuttonE" disabled>
              <RemovePic />
            </button>
          }
          modal
          nested
        >
          {(close) => (
            <div className="mode">
              <button className="close" onClick={close}>
                &times;
              </button>
              <div className="header"> Remove Expense </div>
              <div className="content">
                <ERPopup keydata={row} categories={props.categories} />
                <br />
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }

  function amountformat(cell, row) {
    return <span> ${cell} </span>;
  }

  function categoryformat(cell, row) {
    return (
      <div
        className="category-cell"
        style={{ backgroundColor: getColor(cell) }}
      >
        {cell}
      </div>
    );
  }

  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;

  //the expense table
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      headerClasses: "column-header column-header-name",
      classes: "column-name",
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        if (order === "asc") {
          return dateA.getTime() - dateB.getTime();
        }
        return dateB.getTime() - dateA.getTime();
      },
      headerClasses: "column-header column-date-field",
      classes: "column-data",
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      formatter: amountformat,
      headerClasses: "column-header text-center",
      classes: "column-data text-center",
    },
    {
      dataField: "site",
      text: "Purchased From",
      headerClasses: `column-header non-sortable ${
        props.sideBar ? `column-purchase-form` : ""
      }`,
      classes: "column-data",
    },
    {
      dataField: "category",
      text: "Category",
      formatter: categoryformat,
      sort: true,
      filter: textFilter({ placeholder: "Filter Categories" }),
      headerClasses: "column-header",
      classes: "column-data",
    },
    {
      dataField: "note",
      text: "Note",
      headerClasses: "column-header non-sortable text-center",
      classes: "column-data text-center",
    },
    {
      dataField: "actions",
      text: "",
      formatter: actionformat,
      headerClasses: "column-header non-sortable text-center",
      classes: "column-data text-center",
      csvExport: false,
    },
  ];

  const renderPageList = (options) => (
    <Col className="react-bootstrap-table-pagination-list" md={6}>
      <ul className="pagination react-bootstrap-table-page-btns-ul float-right">
        {options.pages.map((page) => (
          <li
            key={page.page}
            className={`${page.active ? "active-page" : ""}page-item ${page.disabled ? "disable-page" :""}`}
            onClick={() => options.onPageChange(page.page)}
          >
            <div className="page-link">
              {page.page}
            </div>
          </li>
        ))}
      </ul>
    </Col>
  );

  const pagination = paginationFactory({
    sizePerPage: 20,
    firstPageText: "<<",
    lastPageText: ">>",
    alwaysShowAllBtns: true,
    showTotal: true,
    pageListRenderer: renderPageList,
  });

  return (
    <div>
      <Modal
        id="modal-2"
        show={props.completeTutorial}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="all-popover"
      >
        <Modal.Header>
          <Modal.Title>You're all set!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Congratulations! You're ready to begin using Sotira.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={endTutorial} className="modal-button">
            Done
          </Button>
        </Modal.Footer>
      </Modal>
      <ToolkitProvider
        keyField="id"
        data={nrows}
        columns={columns}
        search
        exportCSV
      >
        {(props) => (
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="my-3 d-flex align-items-center">
                <span className="tabletitle"> Expenses </span>
                <SearchIcon
                  id="filtersubmit"
                  className="mr-5 search-table-icon"
                />
                <SearchBar
                  {...props.searchProps}
                  placeholder="Search Table"
                  className="mb-0"
                  disabled
                />
              </div>
              <div>
                <ExportCSVButton className="export-button mr-4 " disabled>
                  <ExportIcon className="mr-2 mb-2 export-icon" />
                  Export To PDF
                </ExportCSVButton>

                <ExportCSVButton className="export-button mr-4" disabled>
                  <ExportIcon className="mr-2 mb-2 export-icon" />
                  Export To CSV
                </ExportCSVButton>
              </div>
            </div>

            <div className="table-wrapper">
              <BootstrapTable
                {...props.baseProps}
                bordered={false}
                filter={filterFactory()}
                pagination={pagination}
                filterPosition="top"
                noDataIndication="Add Expenses above"
                rowClasses="table-hover"
                placement="top"
                wrapperClasses="responsive"
              />
            </div>
          </div>
        )}
      </ToolkitProvider>
      <OverlayTrigger show={show} placement="bottom" overlay={popoverS8}>
        <p id="bottom-page" />
      </OverlayTrigger>
    </div>
  );
}
